import './App.css';
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/templateCss.css";
import {Link, useLocation , BrowserRouter} from 'react-router-dom'
// import {Home} from "@material-ui/icons";
// import store from './redux/store';
// import { Provider } from 'react-redux';
// import { Router } from 'react-router'


import {createBrowserHistory} from 'history';
import { withResizeDetector } from "react-resize-detector";
import MainCompounent from "./Compounents/MainCompounent";
import { Provider } from 'react-redux';
import store from './redux/store';



export const history = createBrowserHistory()
function App({width}) {
    const body = document.querySelector("body");

    width >= 1000
        ? body.setAttribute("data-sidebar-style", "full")
        : width <= 999 && width >= 767
        ? body.setAttribute("data-sidebar-style", "mini")
        : body.setAttribute("data-sidebar-style", "overlay");
  return (
      <Provider store={store}>
          <BrowserRouter history={history}>
              <MainCompounent/>
          </BrowserRouter>
      </Provider>
  );
}

export default withResizeDetector(App);
